import CookieSettings from '../cookieSettings';
import {
	COOKIE_SETTINGS_MODAL
} from '../../constants/modals';

export const mapper = {
	[COOKIE_SETTINGS_MODAL]: CookieSettings
};
